import { $api } from '@service/RequestService';
import { CrmEmployee } from '@utils/models/OneLid';
import { useQuery } from 'react-query';

export function useEmployees() {
  const { data, ...arg } = useQuery<{ employees: CrmEmployee[] }>(
    ['dashboard-v2-employees'],
    async () => {
      const { data } = await $api.get('/v1/lead/employee/all');

      return { employees: data?.data };
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity
    }
  );

  return { ...data, ...arg };
}
